import { render, staticRenderFns } from "./TransitionExpand.vue?vue&type=template&id=50d09b07&scoped=true"
import script from "./TransitionExpand.vue?vue&type=script&lang=js"
export * from "./TransitionExpand.vue?vue&type=script&lang=js"
import style0 from "./TransitionExpand.vue?vue&type=style&index=0&id=50d09b07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d09b07",
  null
  
)

export default component.exports